import React from "react";
import { getInitialData } from "../service/apiFetch";
import ContentPage from "../components/utils/ContentPage";

export const getStaticProps = async () => {
  const initialData = await getInitialData("promotion-rules", {
    contentBlock: "Object",
  });

  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      url: initialData?.url || "",
      error: initialData?.error || "",
    },
  };
};

export default function Promotion({ data }) {
  const block = data?.contentBlock?.PROMOTION || data?.contentBlock?.PROMOTION_RULES;
  return (
    <ContentPage
      heading={block?.heading}
      subHeading={block?.subHeading}
      content={block?.content}
    />
  );
}
